import _regeneratorRuntime from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty2 from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import constant from "lodash/constant";
import assignWith from "lodash/assignWith";
import memoize from 'memoize-one';
import { intlMessageShape, availableValuesIdDisplayNameObject, DATA_TYPE_OBJECT } from '@jutro/prop-types';
import { messages } from './LookupField.messages';
import { FieldComponent } from '../FieldComponent/FieldComponent';
import { GenericSelectControl } from '../GenericSelectControl/GenericSelectControl';
import { LookupOption as Option } from './components/LookupOption';
import { LookupValue as Value } from './components/LookupValue';
import { LookupDropdownIndicator as DropdownIndicator } from './components/LookupDropdownIndicator';
import { LookupClearIndicator as ClearIndicator } from './components/LookupClearIndicator';
import { LookupControl as Control } from './components/LookupControl';
import { LookupMenu as Menu } from './components/LookupMenu';
import { LookupPlaceholder as Placeholder } from './components/LookupPlaceholder';
import styles from "./LookupField.module.css";
var lookupComponents = {
  Option: Option,
  Value: Value,
  DropdownIndicator: DropdownIndicator,
  ClearIndicator: ClearIndicator,
  Control: Control,
  Menu: Menu,
  Placeholder: Placeholder
};
var shouldCreateNew = function shouldCreateNew(text) {
  return !!text;
};
var FALSE = constant(false);
var getOptionTypesMap = memoize(function () {
  var optionTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _reduceInstanceProperty(optionTypes).call(optionTypes, function (map, _ref) {
    var type = _ref.type,
      icon = _ref.icon,
      className = _ref.className,
      displayName = _ref.displayName;
    return _Object$assign(map, _defineProperty2({}, type, {
      icon: icon,
      className: className,
      displayName: displayName
    }));
  }, {});
});
var getMergedStyles = memoize(function (internalClassNames) {
  return internalClassNames ? assignWith(_objectSpread({}, styles), internalClassNames, function (lookupFieldStyle, additionalStyle) {
    return additionalStyle ? cx(lookupFieldStyle, additionalStyle) : lookupFieldStyle;
  }) : styles;
});
var LookupOptionShape = PropTypes.shape(_objectSpread(_objectSpread({}, availableValuesIdDisplayNameObject), {}, {
  type: PropTypes.string.isRequired
}));
export var LookupField = function (_FieldComponent) {
  _inherits(LookupField, _FieldComponent);
  var _super = _createSuper(LookupField);
  function LookupField() {
    var _this;
    _classCallCheck(this, LookupField);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "onInputChangeAX", function (value) {
      if (_this.props.enableGoogleMapsAutocompleteAX) {
        if (value.length >= 5) {
          if (_this.state.service !== null) {
            try {
              _this.state.service.fetchAutocompleteSuggestions({
                input: value,
                includedRegionCodes: ['mx']
              }).then(function (result) {
                var _iterator = _createForOfIteratorHelper(result.suggestions),
                  _step;
                try {
                  var _loop = function _loop() {
                    var suggestion = _step.value;
                    var placeId = suggestion.placePrediction.placeId;
                    var place = suggestion.placePrediction.toPlace();
                    place.fetchFields({
                      fields: ['displayName', 'formattedAddress']
                    }).then(function (response) {
                      var currentPrediction = {
                        "id": placeId,
                        "displayName": place.displayName,
                        "type": "address"
                      };
                      if (!_this.props.availableValues.includes(currentPrediction)) {
                        _this.props.availableValues.push(currentPrediction);
                      }
                    });
                  };
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }).catch(function (error) {
                console.error("Error occurred:", error.message);
              });
            } catch (e) {
              console.log("Error while searching suggestions: " + e);
            }
          }
        } else {
          _this.props.availableValues.length = 0;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (value) {
      _this.beforeValue = _this.props.value;
      _this.notifyChange(value);
      if (_this.props.enableGoogleMapsAutocompleteAX) {
        if (_this.props.onPlaceChangedAX && _this.state.service !== null && value != null) {
          var geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({
            'placeId': value.id
          }, function (results, status) {
            if (status == 'OK') {
              _this.props.onPlaceChangedAX(results[0].geometry.location);
            }
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "recent", _this.props.onLoadValues ? [] : _this.props.availableValues);
    _defineProperty(_assertThisInitialized(_this), "state", {
      recent: _this.recent
    });
    _defineProperty(_assertThisInitialized(_this), "loadValues", function (onLoadValues) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return onLoadValues.apply(void 0, _args2);
            case 2:
              _this.recent = _context2.sent;
              return _context2.abrupt("return", _this.recent);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onMenuClose", function () {
      _this.setState({
        recent: _this.recent
      });
    });
    _this.state = {
      service: null
    };
    return _this;
  }
  _createClass(LookupField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.enableGoogleMapsAutocompleteAX) {
        var timer = setTimeout(function () {
          if (typeof google === "object" && typeof google.maps === "object") {
            _this2.setState({
              service: window.google.maps.places.AutocompleteSuggestion
            });
          }
        }, 5000);
        return function () {
          return clearTimeout(timer);
        };
      }
    }
  }, {
    key: "renderControlReadOnly",
    value: function renderControlReadOnly(breakpointProps) {
      var id = breakpointProps.id,
        value = breakpointProps.value,
        optionTypes = breakpointProps.optionTypes,
        className = breakpointProps.className;
      var optionTypesMap = getOptionTypesMap(optionTypes);
      var mergedStyles = getMergedStyles(this.props.internalClassNames);
      return value && React.createElement("div", {
        id: id,
        "data-read-only": true,
        className: cx(mergedStyles.lookupField, className)
      }, React.createElement(lookupComponents.Value, {
        data: value,
        selectProps: {
          customStyles: mergedStyles,
          optionTypesMap: optionTypesMap
        }
      }));
    }
  }, {
    key: "renderControl",
    value: function renderControl(breakpointProps, _ref3) {
      var isValid = _ref3.isValid,
        labelId = _ref3.labelId;
      var id = breakpointProps.id,
        availableValues = breakpointProps.availableValues,
        className = breakpointProps.className,
        createNewMessage = breakpointProps.createNewMessage,
        isClearable = breakpointProps.isClearable,
        onLoadValues = breakpointProps.onLoadValues,
        onAddNew = breakpointProps.onAddNew,
        optionTypes = breakpointProps.optionTypes,
        placeholder = breakpointProps.placeholder,
        value = breakpointProps.value,
        disabled = breakpointProps.disabled,
        isInitiallyOpen = breakpointProps.isInitiallyOpen,
        internalClassNames = breakpointProps.internalClassNames,
        enableGoogleMapsAutocompleteAX = breakpointProps.enableGoogleMapsAutocompleteAX,
        onPlaceChangedAX = breakpointProps.onPlaceChangedAX;
      var mergedStyles = getMergedStyles(internalClassNames);
      var classes = cx(mergedStyles.lookupField, className);
      var allowNewValue = onAddNew ? shouldCreateNew : FALSE;
      return React.createElement(GenericSelectControl, {
        id: id,
        availableValues: availableValues,
        className: classes,
        components: lookupComponents,
        createNewMessage: createNewMessage,
        defaultOptions: this.state.recent,
        disabled: disabled,
        filter: lookupFilter,
        getOptionValue: getOptionValue,
        getOptionLabel: getOptionLabel,
        isClearable: isClearable,
        allowNewValue: allowNewValue,
        labelId: labelId,
        loadValues: onLoadValues ? this.loadValues(onLoadValues) : undefined,
        onAddNew: onAddNew,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onInputChange: enableGoogleMapsAutocompleteAX ? this.onInputChangeAX : this.onInputChange,
        onMenuClose: this.onMenuClose,
        onValueChange: this.handleValueChange,
        placeholder: placeholder,
        valid: isValid,
        value: value,
        optionTypesMap: getOptionTypesMap(optionTypes),
        customStyles: mergedStyles,
        showRecent: !!onLoadValues,
        isInitiallyOpen: isInitiallyOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _get(_getPrototypeOf(LookupField.prototype), "render", this).call(this);
    }
  }]);
  return LookupField;
}(FieldComponent);
_defineProperty(LookupField, "propTypes", _objectSpread(_objectSpread({}, FieldComponent.propTypes), {}, {
  availableValues: PropTypes.arrayOf(LookupOptionShape),
  optionTypes: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    displayName: intlMessageShape.isRequired
  })),
  createNewMessage: intlMessageShape,
  defaultValue: LookupOptionShape,
  isClearable: PropTypes.bool,
  onLoadValues: PropTypes.func,
  onAddNew: PropTypes.func,
  value: LookupOptionShape,
  isInitiallyOpen: PropTypes.bool,
  internalClassNames: PropTypes.object
}));
_defineProperty(LookupField, "defaultProps", _objectSpread(_objectSpread({}, FieldComponent.defaultProps), {}, {
  createNewMessage: messages.addItem,
  isClearable: true,
  dataType: DATA_TYPE_OBJECT
}));
function lookupFilter(_ref4, text) {
  var displayName = _ref4.displayName;
  var _context;
  return displayName === null || displayName === void 0 ? void 0 : _includesInstanceProperty(_context = displayName.toLowerCase()).call(_context, text.toLowerCase());
}
function getOptionValue(_ref5) {
  var id = _ref5.id;
  return id;
}
function getOptionLabel(_ref6) {
  var displayName = _ref6.displayName;
  return displayName;
}
LookupField.__docgenInfo = {
  componentName: "LookupField",
  packageName: "@jutro/components",
  description: "",
  displayName: "LookupField",
  methods: [{
    name: "handleValueChange",
    docblock: "handle value change\n@param {object} value",
    modifiers: [],
    params: [{
      name: "value",
      description: null,
      type: {
        name: "object"
      },
      optional: false
    }],
    returns: null,
    description: "handle value change"
  }, {
    name: "renderControlReadOnly",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "renderControl",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }, {
      name: "{ isValid, labelId }",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "loadValues",
    docblock: null,
    modifiers: [],
    params: [{
      name: "onLoadValues",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "onMenuClose",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }],
  actualName: "LookupField",
  metadataType: "field",
  props: {
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "LookupOptionShape"
        }
      },
      required: false,
      description: "Array of choice objects to display"
    },
    optionTypes: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            type: {
              name: "string",
              required: true
            },
            icon: {
              name: "string",
              required: true
            },
            className: {
              name: "string",
              required: false
            },
            displayName: {
              name: "union",
              required: true,
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: false
                  },
                  defaultMessage: {
                    name: "string",
                    required: false
                  },
                  args: {
                    name: "shape",
                    value: {},
                    required: false
                  }
                }
              }]
            }
          }
        }
      },
      required: false,
      description: "Description for available option types"
    },
    createNewMessage: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "The message to display when a new options is being created by the user.",
      defaultValue: {
        value: "messages.addItem",
        computed: true
      }
    },
    defaultValue: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Set the default field value on render if there is a default value; needs onValueChange to work"
    },
    isClearable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If true ClearIndicator will be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    onLoadValues: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function for asynchronous data loading"
    },
    onAddNew: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback when new items created"
    },
    value: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Value to display in control"
    },
    isInitiallyOpen: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Should dropdown be initially opened"
    },
    internalClassNames: {
      type: {
        name: "object"
      },
      required: false,
      description: "Map of CSS class names for overriding individual parts of component's styles"
    },
    dataType: {
      defaultValue: {
        value: "DATA_TYPE_OBJECT",
        computed: true
      },
      required: false
    },
    enableGoogleMapsAutocompleteAX: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Func",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onPlaceChangedAX: {
      type: {
        name: "func"
      },
      required: false,
      description: "Func"
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
};